import styled from '@src/styled-components';
import React from 'react';


interface propType {
  children: any;
  visible: boolean;
}

const Tooltip = (props: propType) => {
  return (
    <Wrapper visible={props.visible}>
      {props.children}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  
  height: 40px;
  border-radius: 5px;
  display: flex;
  visibility: ${props => props.visible ? '' : 'hidden'};
  background: white;


  button{
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    
    background: none;
    border: 1px solid #84A1AA;
    color: #84A1AA;
    :hover{
      color: #335D7C;
      border: 1px solid #335D7C;
      cursor: pointer;
    }
  }
  .left-button{
    border-radius: 5px 0px 0px 5px;
  } 
  .right-button{
    border-radius: 0px 5px 5px 0;
  }

`


export default Tooltip
